<template>
  <div id="app">
    <!-- <div id="nav"> -->
    <!-- <router-link to="/"></router-link>  LINK´S QUE NOS MANDA A OTRA PAGINA  -->


    <!-- </div>-->
    <router-view />
    <!-- NUESTRA EL CONTENIDO DEL LINK SELECCIONADO -->
    <!-- <Anormalidades/> -->
    <!-- <b-button variant="success"  @click="showModalSinInternet()">    Descargar Lecturas </b-button> -->


    <!-- MODAL PARA VER SI TIENE ACCESO SIN INTERNET -->
    <b-modal centered id="modal-sin-internet" hide-footer no-close-on-backdrop no-close-on-esc>
      <!-- Personalización del header del modal -->
      <template #modal-header="{ close }">
        <b-button hidden variant="outline-danger" @click="close()">
          Cerrar
        </b-button>
        <div class="w-100 d-flex justify-content-center">
          <h5 class="text-danger m-0">SIN ACCESO A INTERNET</h5>
        </div>
      </template>

      <!-- Contenido del modal -->
      <div class="text-center">
        <img src="/imagenes/no-wifi.png" alt="Cargando" class="mb-3" style="width: 200px; height: auto;" />
        <p class="font-weight-bold text-center">
           Necesitas internet para esta vista. Para operar sin conexión,
            ve aLecturas Offline. xd xd
        </p>
      </div>

      <div class="d-flex justify-content-center w-100 mt-4">
        <b-button variant="success" @click="irLecturasOfline()" class="d-flex  align-items-center">
          <span>
            IR A LECTURAS OFFLINE
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6" style="width: 28px; height: auto;">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
          </svg>
        </b-button>
      </div>
    </b-modal>


    <b-modal id="modal-actualizar-app" hide-footer no-close-on-backdrop no-close-on-esc>
      <!-- Personalización del header del modal -->
      <template #modal-header="{ close }">
        <b-button hidden variant="outline-danger" @click="close()">
          Cerrar
        </b-button>
        <h5 class="text-success m-0 px-3"> ACTUALIZANDO APP </h5>
        <div v-if="!XactualizarApp.actualizar" class="spinner-border spinner-border-sm text-success" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </template>

      <!-- Contenido del modal -->
      <div class="text-center">
        <p> {{ XactualizarApp.mensaje }} </p>
      </div>

      <!-- agregar un boton para actualizar la pantalla  -->
      <div class="text-center">
        <b-button class="w-100" v-if="XactualizarApp.tipo == 1" @click="CerrarModal()">
          Cerrar
        </b-button>

        <div v-else>
          <b-button class="w-100" v-if="XactualizarApp.actualizar" @click="actilizarPagina()">
          Refrescar la página
        </b-button>
        </div>
      </div>


    </b-modal>


  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import { subirLecturaPendiente, limpiarCache } from './dataService';
import store from '@/store/index'
export default {
  name: 'App',

  data() {
    return {
      // showSinConexion: false,
      // customToastContent : `Sin conexion a internet xd!`,
      // bg_color: "bg-danger"
    }
  },

  components: {
    // Anormalidades
  },


  methods: {

    async isOnline() {

      if (navigator.onLine) {

        this.$bvModal.hide('modal-sin-internet');


        // await subirLecturaPendiente();

      } else {

        //antes de abrir modal, verificar si estoy en la lista de vista permitias 
        const laVistaPermitida = ['LecturarPlanillas', 'ClientesALecturar', 'LecturaCliente', 'LecturarOfflineIndex', 'LecturarOfflineEdit', 'Login'];


        if (this.$route.name && !laVistaPermitida.includes(this.$route.name)) {
          this.$bvModal.show('modal-sin-internet');
        }


      }
    },

    irLecturasOfline() {
      this.$bvModal.hide('modal-sin-internet');
      this.$router.push({ name: 'LecturarOfflineIndex' });
    },

    IrLecturaPendientesOffline() {
      this.$router.push({ name: 'LecturarOfflineIndex' });
    },

    showModalSinInternet() {
      this.$bvModal.show('modal-sin-internet');
    },

    actilizarPagina() {
      window.location.reload(); // Recarga la página completa
    },

    CerrarModal() {
      store.dispatch('triggerActualizarApp', { estado: false, mensaje: '', actualizar:false, tipo: 0 });
      window.location.reload(); // Recarga la página completa
  
    },


  },
  created() {

    window.addEventListener('online', () => this.isOnline());
    window.addEventListener('offline', () => this.isOnline());

  },

  mounted() {
    this.isOnline();
  },



  computed: {
    // ...mapGetters(['notificationMessage']),
    ...mapGetters(['XactualizarApp']),
  },

  watch: {
    XactualizarApp: {
      async handler(newValue, oldValue) {
        if (newValue.estado) {
          this.$bvModal.show('modal-actualizar-app');
        } else {
          this.$bvModal.hide('modal-actualizar-app');
        }
      },
      deep: true
    }
  }





}



</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active en versiones anteriores a Vue 2.1.8 */
  {
  opacity: 0;
}
</style>
